import * as Sentry from '@sentry/react';
import { useEffect } from 'react';

let currentApiVersion: string | null = null;

/**
 * Force refresh the page when the API version changes
 */
export const useForceRefresh = (apiVersion: string | null) => {
  useEffect(() => {
    // Set the initial application version
    if (apiVersion && !currentApiVersion) {
      currentApiVersion = apiVersion;
      Sentry.setContext('Craft API', { version: apiVersion });
    }
  }, [apiVersion]);

  useEffect(() => {
    const needsRefresh =
      currentApiVersion !== null && // An apiVersion has been stored in memory
      apiVersion !== null && // ...and an apiVersion has been returned by the heartbeat
      currentApiVersion !== apiVersion; // ...and the stored apiVersion is not the same as the new apiVersion.

    if (needsRefresh) window.location.reload();
  }, [apiVersion]);
};
